export const FISCAL_QUARTER = 1;
export const FISCAL_YEAR = 2;
export const LTM = 3;
export const NTM = 4;
export const LTM_QUARTER = 5;
export const NTM_QUARTER = 6;

export const LAST_TWELVE_MONTHS = 'LAST TWELVE MONTHS';
export const NEXT_TWELVE_MONTHS = 'NEXT TWELVE MONTHS';
